(function () {
  'use strict';

  /* ---------------- money formatting (uses Shopify.formatMoney if present) ---------------- */
  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme_money_format) {
      return Shopify.formatMoney(cents, window.theme_money_format);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------------- mobile menu drawer ---------------- */
  var menuDrawer = document.querySelector('[data-nv2-menu-drawer]');
  var menuOpenBtns = document.querySelectorAll('[data-nv2-menu-open]');
  var menuCloseTimer = null;

  function openMenuDrawer() {
    if (!menuDrawer) return;
    clearTimeout(menuCloseTimer);
    menuDrawer.hidden = false;
    menuOpenBtns.forEach(function (b) { b.classList.add('is-active'); });
    void menuDrawer.offsetWidth;
    requestAnimationFrame(function () { menuDrawer.classList.add('is-open'); });
  }

  function closeMenuDrawer() {
    if (!menuDrawer) return;
    menuDrawer.classList.remove('is-open');
    menuOpenBtns.forEach(function (b) { b.classList.remove('is-active'); });
    var panel = menuDrawer.querySelector('.nv2-menu-drawer__panel');
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      menuDrawer.hidden = true;
      if (panel) panel.removeEventListener('transitionend', finish);
    }
    if (panel) panel.addEventListener('transitionend', finish);
    menuCloseTimer = setTimeout(finish, 500);
  }

  menuOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', openMenuDrawer);
  });
  if (menuDrawer) {
    menuDrawer.querySelectorAll('[data-nv2-menu-close]').forEach(function (el) {
      el.addEventListener('click', closeMenuDrawer);
    });
  }

  /* ---------------- cart drawer ---------------- */
  var drawer = document.querySelector('[data-nv2-drawer]');
  if (!drawer) return;

  var els = {
    count: drawer.querySelector('[data-nv2-drawer-count]'),
    scroll: drawer.querySelector('[data-nv2-drawer-scroll]'),
    items: drawer.querySelector('[data-nv2-drawer-items]'),
    empty: drawer.querySelector('[data-nv2-drawer-empty]'),
    rewards: drawer.querySelector('[data-nv2-rewards]'),
    rewardsIconCart: drawer.querySelector('[data-nv2-rewards-icon-cart]'),
    rewardsIconCheck: drawer.querySelector('[data-nv2-rewards-icon-check]'),
    rewardsTitle: drawer.querySelector('[data-nv2-rewards-title]'),
    rewardsSub: drawer.querySelector('[data-nv2-rewards-sub]'),
    rewardsBadge: drawer.querySelector('[data-nv2-rewards-badge]'),
    rewardsCta: drawer.querySelector('[data-nv2-rewards-cta]'),
    tierbarSegs: drawer.querySelectorAll('[data-nv2-tierbar-seg]'),
    discountRows: drawer.querySelector('[data-nv2-discount-rows]'),
    discountDivider: drawer.querySelector('[data-nv2-discount-divider]'),
    finalTotal: drawer.querySelector('[data-nv2-final-total]'),
    checkout: drawer.querySelector('[data-nv2-checkout]')
  };
  var tpl = document.getElementById('nv2-line-item-template');
  var tiers = [
    { qty: parseInt(drawer.dataset.tier2Qty, 10), pct: parseFloat(drawer.dataset.tier2Pct) },
    { qty: parseInt(drawer.dataset.tier3Qty, 10), pct: parseFloat(drawer.dataset.tier3Pct) },
    { qty: parseInt(drawer.dataset.tier4Qty, 10), pct: parseFloat(drawer.dataset.tier4Pct) }
  ];
  var freeShipAmount = parseInt(drawer.dataset.freeShippingAmount, 10) || 4500;
  var freeShipQty = parseInt(drawer.dataset.freeShippingQty, 10) || 2;

  drawer.querySelectorAll('[data-nv2-tierbar-pct]').forEach(function (el) {
    var tier = tiers[parseInt(el.dataset.nv2TierbarPct, 10)];
    if (tier) el.textContent = '−' + tier.pct + '%';
  });

  var drawerCloseTimer = null;
  function openDrawer() {
    drawer.hidden = false;
    refreshCart();
    void drawer.offsetWidth;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
  }
  function closeDrawer() {
    /* A discount code applied here would otherwise ride Shopify's own 2-week cart cookie
       (shopify.com/legal/cookies: `cart` cookie duration) — silently attaching itself to
       every order the shopper places in that window, not just the one they meant it for.
       Per explicit request, clear it the moment the drawer closes instead: the code is only
       ever meant to be active for the session the shopper typed it in. hasAppliedDiscountCode
       is kept in sync by renderTotals() on every render, so this also catches a code that was
       already sitting on the cart from an earlier visit. Fire-and-forget: the drawer is
       already animating shut, so clearing doesn't need to block that. */
    if (hasAppliedDiscountCode) {
      removeDiscountCode();
    }
    drawer.classList.remove('is-open');
    var panel = drawer.querySelector('.nv2-drawer__panel');
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      drawer.hidden = true;
      if (panel) panel.removeEventListener('transitionend', finish);
    }
    if (panel) panel.addEventListener('transitionend', finish);
    clearTimeout(drawerCloseTimer);
    drawerCloseTimer = setTimeout(finish, 500);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nv2-cart-open]')) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest('[data-nv2-cart-close]')) {
      closeDrawer();
    }
  });

  /* ---------------- discount code (drawer footer) ----------------
     Collapsed behind a "Turite nuolaidos kodą?" toggle by default (same disclosure pattern
     as [data-nv2-review-toggle] on the PDP) — clicking it hides the toggle and shows the
     field IN ITS PLACE, rather than the toggle staying put and the form appending extra
     height below it. Once a code is applied, the whole toggle+form bar disappears entirely
     (see renderTotals()'s applied-state transition below) — only one code can be active at a
     time, so there is nothing to enter until this one clears.

     "Pritaikyti" applies the code WITHOUT leaving the drawer: POST /cart/update.js with a
     `discount` string is the classic Ajax Cart API's actual way to attach a discount code to
     the cart (the same endpoint removeDiscountCode() below already uses to clear one) — it
     returns the same shape as /cart.js, including discount_codes[].applicable, so a bad code
     can be caught and shown inline instead of only failing silently at checkout.

     It's cleared again automatically as soon as the drawer closes (see hasAppliedDiscountCode
     / closeDrawer() above) — otherwise it would ride Shopify's ~2-week cart cookie and quietly
     apply to every order the shopper places in that window, not just the one they entered it
     for. */
  var discountToggle = drawer.querySelector('[data-nv2-discount-toggle]');
  var discountForm = drawer.querySelector('[data-nv2-discount-form]');
  var hasAppliedDiscountCode = false; /* kept in sync by renderTotals() on every render */
  if (discountToggle && discountForm) {
    discountToggle.addEventListener('click', function () {
      discountToggle.hidden = true;
      discountForm.hidden = false;
      var input = discountForm.querySelector('[data-nv2-discount-input]');
      if (input) input.focus();
    });
  }
  if (discountForm) {
    var discountBtn = discountForm.querySelector('.nv2-drawer__discount-btn');

    function showDiscountError(message) {
      var err = discountForm.querySelector('[data-nv2-discount-err]');
      if (!err) {
        err = document.createElement('div');
        err.setAttribute('data-nv2-discount-err', '');
        err.className = 'nv2-atc-error';
        discountForm.appendChild(err);
      }
      err.textContent = message;
      err.hidden = false;
    }
    function clearDiscountError() {
      var err = discountForm.querySelector('[data-nv2-discount-err]');
      if (err) err.hidden = true;
    }

    discountForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = discountForm.querySelector('[data-nv2-discount-input]');
      var code = (input.value || '').trim();
      if (!code) return;
      clearDiscountError();
      if (discountBtn) discountBtn.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var applied = (cart.discount_codes || []).some(function (d) {
            return d.code.toLowerCase() === code.toLowerCase() && d.applicable;
          });
          if (applied) {
            input.value = '';
          } else {
            showDiscountError('Nuolaidos kodas negalioja arba nebeaktyvus.');
          }
          /* /cart/update.js nests cart_level_discount_applications one level deeper
             (app.discount_application.total_allocated_amount / .title / .type) than
             /cart.js does — the same shape quirk changeLine() below already works around
             for /cart/change.js. renderTotals() only reads the flat /cart.js shape, so
             painting THIS response directly silently dropped the applied code's own row
             (it still updated the final total, since total_price is flat either way).
             Re-fetching /cart.js renders from the shape renderTotals() actually expects. */
          return refreshCart();
        })
        .catch(function () {
          showDiscountError('Nepavyko pritaikyti kodo. Bandykite dar kartą.');
        })
        .finally(function () { if (discountBtn) discountBtn.disabled = false; });
    });
  }

  /* Clears whatever discount code is currently attached to the cart. Used by closeDrawer()
     above to auto-clear an applied code the moment the drawer closes — see the comment there
     for why (Shopify's own cart cookie would otherwise keep a code active for ~2 weeks,
     across every order the shopper places in that window). POST /cart/update.js with an
     empty `discount` string is the classic Ajax Cart API's way to do this without touching
     line items or requiring a trip through checkout. */
  function removeDiscountCode() {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function () { return refreshCart(); });
  }

  function tierFor(qty) {
    var current = { pct: 0, qty: 0 };
    var next = null;
    tiers.forEach(function (t) {
      if (qty >= t.qty && t.qty > current.qty) current = t;
      if (qty < t.qty && (next === null || t.qty < next.qty)) next = t;
    });
    return { current: current, next: next };
  }

  var capCache = Object.create(null);

  function fetchCompareAt(handles) {
    var missing = [];
    handles.forEach(function (h) {
      if (h && !(h in capCache) && missing.indexOf(h) === -1) missing.push(h);
    });
    if (!missing.length) return Promise.resolve();
    return Promise.all(missing.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var map = Object.create(null);
          if (p && p.variants) {
            p.variants.forEach(function (v) {
              var c = v.compare_at_price;
              if (c == null) return;
              c = typeof c === 'number' ? Math.round(c) : Math.round(parseFloat(c) * 100);
              if (c > 0) map[v.id] = c;
            });
          }
          capCache[h] = map;
        })
        .catch(function () { capCache[h] = Object.create(null); });
    }));
  }

  function capFor(item) {
    var map = capCache[item.handle];
    var c = map ? map[item.variant_id] : 0;
    return c && c > item.original_price ? c : 0;
  }

  /* Returns both the euro amount saved via compare-at markdown AND a blended percentage
     (savings / sum of compare-at prices) so the totals row can show "Prekių nuolaida: -50%"
     the same way the automatic/code discounts already show their own percentage. */
  function markdownTotal(cart) {
    var sum = 0;
    var compareAtSum = 0;
    (cart.items || []).forEach(function (item) {
      var c = capFor(item);
      if (c) {
        sum += (c - item.original_price) * item.quantity;
        compareAtSum += c * item.quantity;
      }
    });
    return { amount: sum, pct: compareAtSum > 0 ? Math.round((sum / compareAtSum) * 100) : 0 };
  }

  function renderRewards(cart) {
    var qty = cart.item_count;
    if (qty === 0) { els.rewards.hidden = true; return; }
    var t = tierFor(qty);
    els.rewards.hidden = false;

    var filledSegs = Math.min(qty, 4);
    els.tierbarSegs.forEach(function (seg, i) {
      seg.classList.toggle('is-filled', i < filledSegs);
    });

    if (t.next) {
      els.rewards.classList.remove('is-max');
      els.rewardsIconCart.hidden = false;
      els.rewardsIconCheck.hidden = true;
      els.rewardsCta.hidden = false;

      els.rewardsTitle.textContent = 'Įdėkite dar 1 prekę';

      var alreadyFreeShip = cart.total_price >= freeShipAmount || qty >= freeShipQty;
      /* Only mention free shipping in the subtitle when reaching the NEXT tier is what newly
         unlocks it. Previously this also fired whenever free shipping was ALREADY active
         (alreadyFreeShip on its own OR'd in), so "ir nemokamą pristatymą" kept repeating on
         every later tier's subtitle (e.g. at 2 items, already shipping-free, the -15% and
         -20% prompts still said "ir nemokamą pristatymą" as if it still needed earning) —
         reported as confusing/redundant. Now it only shows the one time it's actually new. */
      var willUnlockFreeShip = !alreadyFreeShip && t.next.qty >= freeShipQty;
      var sub = 'Gausite −' + t.next.pct + '% visam užsakymui';
      if (willUnlockFreeShip) {
        sub += ' ir nemokamą pristatymą';
      }
      els.rewardsSub.textContent = sub;
      els.rewardsBadge.textContent = '−' + t.next.pct + '%';
    } else {
      els.rewards.classList.add('is-max');
      els.rewardsIconCart.hidden = true;
      els.rewardsIconCheck.hidden = false;
      els.rewardsCta.hidden = true;

      els.rewardsTitle.textContent = 'Maksimali kiekio nuolaida pritaikyta';
      els.rewardsSub.textContent = (cart.total_price >= freeShipAmount || qty >= freeShipQty) ? 'Pristatymas nemokamas' : '';
      els.rewardsBadge.textContent = '−' + t.current.pct + '%';
    }
  }

  function renderTotals(cart, markdownInfo) {
    els.discountRows.innerHTML = '';
    var apps = cart.cart_level_discount_applications || [];
    var appTitles = {};
    apps.forEach(function (app) { appTitles[app.title] = true; });

    /* Kiekio nuolaida is now a PRODUCT-class discount (scoped to the "Visos prekės"
       collection) rather than ORDER-class — that's what lets it combine with an ORDER-class
       discount code (RUDUO15) while the three tiers still stay mutually exclusive with EACH
       OTHER (Shopify's combinesWith is per-class, not per-discount-pair — keeping both the
       code combo AND tier exclusivity needs them in different classes). The tradeoff: a
       product-class discount is never listed in cart.cart_level_discount_applications — it
       only shows up per line item, in item.discounts[]. So it has to be summed from there
       instead. Any title already present in cart_level_discount_applications (RUDUO15) is
       skipped here, since item.discounts[] repeats it per line and cart_level's own
       total_allocated_amount is already the correct cart-wide figure. */
    var lineDiscountTotals = {};
    var lineDiscountOrder = [];
    (cart.items || []).forEach(function (item) {
      (item.discounts || []).forEach(function (d) {
        if (appTitles[d.title]) return;
        if (!(d.title in lineDiscountTotals)) {
          lineDiscountTotals[d.title] = 0;
          lineDiscountOrder.push(d.title);
        }
        lineDiscountTotals[d.title] += d.amount;
      });
    });

    var nowHasCode = apps.some(function (app) { return app.type === 'discount_code'; });
    /* Toggle/form visibility only reacts to a CHANGE in applied-code state, not to every
       render — paintCart() runs after every cart mutation, including unrelated qty changes
       elsewhere in the cart, so reacting on every render would force-collapse an in-progress,
       not-yet-submitted code entry the instant the shopper changed something else. Once a
       code IS active, the entire "Turite nuolaidos kodą?" bar disappears — per explicit
       request, only one code can be entered at a time, and there's nothing to type until
       this one clears (closeDrawer() clears it automatically on close). */
    if (nowHasCode !== hasAppliedDiscountCode && discountToggle && discountForm) {
      discountToggle.hidden = nowHasCode;
      discountForm.hidden = true;
    }
    hasAppliedDiscountCode = nowHasCode;

    var rowsToRender = [];
    if (markdownInfo.amount > 0) {
      /* Colon goes right after the label, BEFORE the percentage — "Prekių nuolaida: -50%",
         not "Prekių nuolaida -50%:" — per explicit correction. */
      var markdownTitle = 'Prekių nuolaida:' + (markdownInfo.pct > 0 ? ' -' + markdownInfo.pct + '%' : '');
      rowsToRender.push({ title: markdownTitle, amount: markdownInfo.amount });
    }
    /* Kiekio nuolaida titles already carry their own "−X%" set in Shopify Admin, so no
       percentage math is needed here — just the summed euro amount per title. */
    lineDiscountOrder.forEach(function (title) {
      if (lineDiscountTotals[title] > 0) {
        rowsToRender.push({ title: title, amount: lineDiscountTotals[title] });
      }
    });
    if (apps.length > 0) {
      apps.forEach(function (app) {
        if (app.total_allocated_amount > 0) {
          var pct = app.value_type === 'percentage' ? Math.round(parseFloat(app.value)) : 0;
          /* Automatic/coded discounts sometimes already bake their own "−10%" etc. into the
             title set in Shopify Admin — only append our own when the title doesn't already
             carry one (RUDUO15 and other plain discount-code titles never do). */
          var title = (pct > 0 && app.title.indexOf('%') === -1) ? app.title + ' -' + pct + '%' : app.title;
          rowsToRender.push({ title: title, amount: app.total_allocated_amount });
        }
      });
    } else if (!markdownInfo.amount && !lineDiscountOrder.length && cart.total_discount > 0) {
      rowsToRender.push({ title: 'Prekių nuolaida:', amount: cart.total_discount });
    }
    /* Free-shipping status line — same threshold the "Įdėkite dar 1 prekę" reward card above
       already promises (freeShipAmount / freeShipQty, merchant-configurable in the section
       settings), just surfaced again down here in the totals list once it's actually met, so
       the shopper sees it confirmed right next to the price they're about to pay. Rendered
       with a plain "Nemokamas" label instead of a −money amount, since there's no shipping
       charge on the cart to subtract from — it's a status, not a discount. */
    if (cart.item_count > 0 && (cart.total_price >= freeShipAmount || cart.item_count >= freeShipQty)) {
      rowsToRender.push({ title: 'Pristatymas:', isShipping: true });
    }
    /* "Iš viso sutaupote: X€" total-savings recap — pushed as the LAST row in this same
       itemised list (per explicit request: in the bar with the other discounts, right after
       "Pristatymas"), not a separate block elsewhere. Sums the SAME rows already itemised
       above (never a separately computed number, so it can never disagree with them) —
       excluding the free-shipping row, since that's a status label with no euro amount to
       add. Wording is "Iš viso sutaupote:" (not just "Sutaupote") specifically to signal this
       is the TOTAL of the rows above, not one more separate discount — chosen over the
       grammatically-precise future tense "Sutaupysite" because the present-tense framing
       (savings already achieved) reads as psychologically stronger. Rendered bold in a
       distinct red (isSavings, styled in CSS) so it still reads as the summary line. */
    var totalSavings = 0;
    rowsToRender.forEach(function (row) {
      if (!row.isShipping) totalSavings += row.amount;
    });
    if (totalSavings > 0) {
      rowsToRender.push({ title: 'Iš viso sutaupote:', amount: totalSavings, isSavings: true });
    }
    rowsToRender.forEach(function (row) {
      var el = document.createElement('div');
      el.className = 'nv2-drawer__totals-row' + (row.isSavings ? ' nv2-drawer__totals-row--savings' : '');
      el.innerHTML = '<span></span><span class="nv2-drawer__totals-val nv2-drawer__totals-val--teal"></span>';
      el.firstElementChild.textContent = row.title;
      el.lastElementChild.textContent = row.isShipping ? 'Nemokamas' : (row.isSavings ? money(row.amount) : ('−' + money(row.amount)));
      els.discountRows.appendChild(el);
    });
    els.discountDivider.hidden = rowsToRender.length === 0;
    els.finalTotal.textContent = money(cart.total_price);
    els.checkout.href = '/checkout';
  }

  function lineItemNode(item) {
    var node = tpl.content.firstElementChild.cloneNode(true);
    var img = node.querySelector('[data-nv2-item-img]');
    if (item.image) {
      img.src = item.image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_240x$1$2');
      img.alt = item.title;
    } else {
      img.remove();
    }
    var titleEl = node.querySelector('[data-nv2-item-title]');
    titleEl.textContent = item.product_title || item.title;
    titleEl.href = item.url;

    (item.options_with_values || []).forEach(function (opt) {
      var name = (opt.name || '').toLowerCase();
      if (name.indexOf('spal') > -1 || name === 'color' || name === 'colour') {
        var c = node.querySelector('[data-nv2-item-color]');
        c.hidden = false;
        c.querySelector('[data-nv2-item-color-val]').textContent = opt.value;
      }
      if (name.indexOf('dyd') > -1 || name === 'size') {
        var s = node.querySelector('[data-nv2-item-size]');
        s.hidden = false;
        s.querySelector('[data-nv2-item-size-val]').textContent = opt.value;
      }
    });

    /* Cart line item properties (properties[...]) — generic display for ANY product that
       collects extra per-line details at add-to-cart (currently only the moherio-mezgimo-
       siulu-rinkinys 10 vnt. bundle's two colour <select>s, see sections/nv2-main-product.
       liquid). Shopify's own _-prefixed keys are reserved/internal and never meant for
       customer display, so they're filtered out; everything else renders as its own
       "Key: value" row, reusing .nv2-drawer__item-variant's existing styling. */
    var propsWrap = node.querySelector('[data-nv2-item-props]');
    if (propsWrap) {
      var propKeys = Object.keys(item.properties || {}).filter(function (k) {
        return k.charAt(0) !== '_' && item.properties[k];
      });
      if (propKeys.length) {
        propsWrap.hidden = false;
        propKeys.forEach(function (k) {
          var row = document.createElement('div');
          row.className = 'nv2-drawer__item-variant';
          row.textContent = k + ': ' + item.properties[k];
          propsWrap.appendChild(row);
        });
      }
    }

    node.querySelector('[data-nv2-item-qty]').textContent = item.quantity;
    var priceNow = node.querySelector('[data-nv2-item-price-now]');
    var priceOld = node.querySelector('[data-nv2-item-price-old]');
    priceNow.textContent = money(item.final_line_price);
    var cap = capFor(item);
    var oldLine = cap ? cap * item.quantity : item.original_line_price;
    if (oldLine > item.final_line_price) {
      priceOld.hidden = false;
      priceOld.textContent = money(oldLine);
    }

    function disableStepper() {
      node.querySelectorAll('[data-nv2-qty-minus],[data-nv2-qty-plus],[data-nv2-item-remove]').forEach(function (b) { b.disabled = true; });
    }
    node.querySelector('[data-nv2-qty-minus]').addEventListener('click', function () {
      disableStepper();
      changeLine(item.key, item.quantity - 1);
    });
    node.querySelector('[data-nv2-qty-plus]').addEventListener('click', function () {
      disableStepper();
      changeLine(item.key, item.quantity + 1);
    });
    node.querySelector('[data-nv2-item-remove]').addEventListener('click', function () {
      disableStepper();
      changeLine(item.key, 0);
    });

    return node;
  }

  function renderCart(cart) {
    var handles = (cart.items || []).map(function (i) { return i.handle; });
    fetchCompareAt(handles).then(function () { paintCart(cart); }, function () { paintCart(cart); });
  }

  function paintCart(cart) {
    els.count.textContent = cart.item_count;
    document.querySelectorAll('[data-nv2-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
    document.querySelectorAll('[data-nv2-cart-total]').forEach(function (n) { n.textContent = money(cart.total_price); });

    els.items.innerHTML = '';
    if (cart.item_count === 0) {
      els.empty.hidden = false;
    } else {
      els.empty.hidden = true;
      cart.items.forEach(function (item) {
        els.items.appendChild(lineItemNode(item));
      });
    }
    var markdown = markdownTotal(cart);
    renderRewards(cart);
    renderTotals(cart, markdown);
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  var cartRequestChain = Promise.resolve();

  function changeLine(key, quantity) {
    cartRequestChain = cartRequestChain
      .then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
      })
      .then(function () { return refreshCart(); })
      .catch(function () { return refreshCart(); });
    return cartRequestChain;
  }

  window.nv2AddToCart = function (formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(formData)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () {
      openDrawer();
    }).catch(function (e) {
      window.alert((e && e.message) || 'Nepavyko įdėti prekės į krepsėlį. Bandykite dar kartą.');
      throw e;
    });
  };

  function showAddToCartError(form, message) {
    var err = form.querySelector('[data-nv2-atc-error]');
    if (!err) {
      err = document.createElement('div');
      err.setAttribute('data-nv2-atc-error', '');
      err.className = 'nv2-atc-error';
      form.appendChild(err);
    }
    err.textContent = message;
    err.hidden = false;
  }
  function clearAddToCartError(form) {
    var err = form.querySelector('[data-nv2-atc-error]');
    if (err) err.hidden = true;
  }

  function addToCartFromForm(form, submitBtn) {
    if (submitBtn) submitBtn.disabled = true;
    clearAddToCartError(form);
    var fd = new FormData(form);
    /* properties[...] fields (line item properties, e.g. a customer's free-text color pick
       for a bundle variant) used to be silently dropped here — only `id`/`quantity` were
       ever read off the form. Any field named properties[Key] now rides along too, exactly
       as Shopify's own Ajax Cart API expects it, so a product whose buy-box collects extra
       per-line details (see sections/nv2-main-product.liquid's moherio-mezgimo-siulu-rinkinys
       bundle picker) actually reaches the cart instead of losing that data at add-to-cart. */
    var item = { id: fd.get('id'), quantity: fd.get('quantity') || 1 };
    var properties = {};
    var hasProperties = false;
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m) {
        properties[m[1]] = value;
        hasProperties = true;
      }
    });
    if (hasProperties) item.properties = properties;
    var payload = { items: [item] };
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          showAddToCartError(form, (result.data && result.data.message) || 'Nepavyko įdėti prekės į krepsėlį. Bandykite dar kartą.');
          return;
        }
        openDrawer();
      })
      .catch(function () {
        showAddToCartError(form, 'Nepavyko įdėti prekės į krepsėlį. Patikrinkite interneto ryšį ir bandykite dar kartą.');
      })
      .finally(function () { if (submitBtn) submitBtn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nv2-card__form [type="submit"], .nv2-pdp-atc-form [type="submit"]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCartFromForm(form, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('.nv2-card__form, .nv2-pdp-atc-form')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  refreshCart();

  function pad(n) { return String(n).padStart(2, '0'); }
  var TEN_HOURS_MS = 10 * 3600 * 1000;
  function msRemainingInCycle() {
    return TEN_HOURS_MS - (Date.now() % TEN_HOURS_MS);
  }
  document.querySelectorAll('[data-nv2-countdown]').forEach(function (el) {
    var hEl = el.querySelector('[data-cd-h]');
    var mEl = el.querySelector('[data-cd-m]');
    var sEl = el.querySelector('[data-cd-s]');
    function render() {
      var remaining = Math.floor(msRemainingInCycle() / 1000);
      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    render();
    var timer = setInterval(render, 1000);
    window.addEventListener('pagehide', function () { clearInterval(timer); });
  });

  document.querySelectorAll('[data-nv2-scrollrow]').forEach(function (row) {
    var track = row.querySelector('[data-nv2-scrolltrack]') || row;
    var backBtn = row.querySelector('[data-nv2-scroll-back]');
    var fwdBtns = row.querySelectorAll('[data-nv2-scroll-fwd]');
    function updateBack() {
      if (backBtn) backBtn.hidden = track.scrollLeft <= 10;
    }
    track.addEventListener('scroll', updateBack, { passive: true });
    updateBack();
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
      });
    }
    fwdBtns.forEach(function (fwdBtn) {
      fwdBtn.addEventListener('click', function (e) {
        if (fwdBtn.tagName === 'A' && fwdBtn.getAttribute('href') && fwdBtn.getAttribute('href') !== '#') return;
        e.preventDefault();
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
        if (atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
        }
      });
    });
  });

  document.querySelectorAll('[data-nv2-autoscroll]').forEach(function (el) {
    if (window.innerWidth <= 989) return;

    var speed = 0.5;
    var paused = false;
    var pos = el.scrollLeft;
    function step() {
      if (!paused && el.scrollWidth > el.clientWidth) {
        var max = el.scrollWidth - el.clientWidth;
        pos += speed;
        if (pos >= max) pos = 0;
        el.scrollLeft = pos;
      }
      requestAnimationFrame(step);
    }
    function pause() { paused = true; }
    function resume() { paused = false; pos = el.scrollLeft; }
    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', resume);
    el.addEventListener('touchstart', pause, { passive: true });
    el.addEventListener('touchend', resume);
    el.addEventListener('touchcancel', resume);
    el.addEventListener('pointerdown', pause);
    el.addEventListener('pointerup', resume);
    el.addEventListener('pointercancel', resume);
    requestAnimationFrame(step);
  });

  document.querySelectorAll('[data-nv2-pillfilters]').forEach(function (form) {
    var pills = form.querySelectorAll('[data-nv2-pill]');
    function closeAll(except) {
      pills.forEach(function (p) {
        if (p === except) return;
        var dd = p.querySelector('[data-nv2-pill-dropdown]');
        if (dd) dd.hidden = true;
      });
    }
    pills.forEach(function (pill) {
      var toggle = pill.querySelector('[data-nv2-pill-toggle]');
      var dropdown = pill.querySelector('[data-nv2-pill-dropdown]');
      if (!toggle || !dropdown) return;
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = dropdown.hidden;
        closeAll();
        dropdown.hidden = !willOpen;
      });
      dropdown.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    document.addEventListener('click', function () { closeAll(); });

    form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () { form.submit(); });
    });
    var sortSelect = form.querySelector('[data-nv2-pill-autosubmit]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () { form.submit(); });
    }
  });

  document.querySelectorAll('[data-nv2-pill][data-nv2-filter-label]').forEach(function (pill) {
    var url = pill.getAttribute('data-nv2-color-groups-url');
    var filterLabel = pill.getAttribute('data-nv2-filter-label');
    var dropdown = pill.querySelector('[data-nv2-pill-dropdown]');
    var form = pill.closest('form');
    if (!url || !dropdown || !form) return;

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (allGroups) {
        var groups = allGroups[filterLabel];
        if (!groups) return;

        var order = groups.__order__;

        var rawToCanonical = {};
        Object.keys(groups).forEach(function (canonical) {
          if (canonical === '__order__') return;
          groups[canonical].forEach(function (raw) {
            if (!rawToCanonical[raw]) rawToCanonical[raw] = [];
            rawToCanonical[raw].push(canonical);
          });
        });

        var labels = Array.prototype.slice.call(dropdown.querySelectorAll('label.nv2-pillfilters__option'));
        var byCanonical = {};

        labels.forEach(function (label) {
          var input = label.querySelector('input[type="checkbox"]');
          if (!input) return;
          var canonicals = rawToCanonical[input.value];
          if (!canonicals || canonicals.length === 0) {
            label.style.display = 'none';
            input.disabled = true;
            return;
          }
          canonicals.forEach(function (canonical) {
            if (!byCanonical[canonical]) byCanonical[canonical] = { representative: null, inputs: [], count: 0 };
            var countEl = label.querySelector('.nv2-pillfilters__option-count');
            byCanonical[canonical].inputs.push(input);
            byCanonical[canonical].count += (countEl ? parseInt(countEl.textContent, 10) || 0 : 0);
            if (!byCanonical[canonical].representative) {
              byCanonical[canonical].representative = label;
            }
          });
        });

        labels.forEach(function (label) { label.style.display = 'none'; });

        var sortedCanonicals = Object.keys(byCanonical).sort(function (a, b) {
          if (order) {
            var ia = order.indexOf(a);
            var ib = order.indexOf(b);
            if (ia === -1 && ib === -1) return a.localeCompare(b, 'lt');
            if (ia === -1) return 1;
            if (ib === -1) return -1;
            return ia - ib;
          }
          return a.localeCompare(b, 'lt');
        });

        sortedCanonicals.forEach(function (canonical) {
          var group = byCanonical[canonical];
          var repLabel = group.representative;
          var repInput = repLabel.querySelector('input[type="checkbox"]');
          var labelSpan = repLabel.querySelector('.nv2-pillfilters__option-label');
          var countSpan = repLabel.querySelector('.nv2-pillfilters__option-count');

          repLabel.style.display = '';
          dropdown.appendChild(repLabel);
          if (labelSpan) labelSpan.textContent = canonical;
          if (countSpan) countSpan.textContent = group.count;
          repInput.checked = group.inputs.some(function (inp) { return inp.checked; });

          repLabel.addEventListener('click', function (e) {
            e.preventDefault();
            var next = !repInput.checked;
            group.inputs.forEach(function (inp) { inp.checked = next; });
            form.submit();
          });
        });
      })
      .catch(function () { });
  });

  document.querySelectorAll('[data-nv2-stock-pill]').forEach(function (pill) {
    var num = pill.querySelector('[data-nv2-stock-num]');
    if (num) num.textContent = Math.floor(Math.random() * 8) + 3;
  });

  document.querySelectorAll('[data-nv2-card-stock]').forEach(function (el) {
    var qty = Math.floor(Math.random() * 10) + 3;
    el.textContent = 'Liko ' + qty + ' vnt.';
  });

  document.querySelectorAll('[data-nv2-faq-row]').forEach(function (row) {
    row.addEventListener('click', function () {
      var open = row.getAttribute('aria-expanded') === 'true';
      row.setAttribute('aria-expanded', String(!open));
      row.classList.toggle('is-open', !open);
    });
  });

  document.querySelectorAll('[data-nv2-review-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.querySelector('[data-nv2-review-form]');
      if (form) form.hidden = !form.hidden;
    });
  });
  document.querySelectorAll('[data-nv2-star-pick]').forEach(function (star) {
    star.addEventListener('click', function () {
      var val = parseInt(star.getAttribute('data-nv2-star-pick'), 10);
      var group = star.closest('[data-nv2-star-group]');
      if (!group) return;
      group.querySelectorAll('[data-nv2-star-pick]').forEach(function (s) {
        s.classList.toggle('is-active', parseInt(s.getAttribute('data-nv2-star-pick'), 10) <= val);
      });
      var input = group.querySelector('input[type="hidden"]');
      if (input) input.value = val;
      group.classList.remove('is-invalid');
    });
  });
  document.querySelectorAll('.nv2-review-form__inner').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var group = form.querySelector('[data-nv2-star-group]');
      if (!group) return;
      var input = group.querySelector('input[type="hidden"]');
      if (!input || !input.value) {
        e.preventDefault();
        group.classList.add('is-invalid');
        group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  document.querySelectorAll('.nv2-pdp__gallery').forEach(function (gallery) {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-nv2-thumb]'));
    var track = gallery.querySelector('[data-nv2-slides]');
    if (!thumbs.length || !track) return;
    var counter = gallery.querySelector('[data-nv2-counter]');
    var len = thumbs.length;

    function setActive(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      if (counter) counter.textContent = (index + 1) + ' / ' + len;
    }
    function currentIndex() {
      return Math.round(track.scrollLeft / track.clientWidth) || 0;
    }
    function goTo(index, smooth) {
      index = ((index % len) + len) % len;
      var isSmooth = smooth !== false;
      /* iOS Safari fights a programmatic scrollTo on an element that has
         scroll-snap-type: mandatory (set in nv2-product.css's mobile media query for this
         same track, for real finger-swipe snapping) — it silently snaps back to wherever the
         track already was instead of moving to the requested slide. Confirmed live: a design
         picked in the siulai-rinkinys bundle's select (see the data-nv2-design-select
         listener below) updated the active thumb/counter correctly but the visible photo
         never moved, only on a real iPhone (not reproducible in this Chromium-based tool's
         mobile emulation, which doesn't have the same snap-vs-JS-scroll conflict). Turning
         snap off for the moment of the jump, then back on once it's settled, sidesteps it. */
      var prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.scrollTo({ left: index * track.clientWidth, behavior: isSmooth ? 'smooth' : 'instant' });
      setActive(index);
      setTimeout(function () { track.style.scrollSnapType = prevSnap; }, isSmooth ? 400 : 50);
    }

    /* Exposed so controls OUTSIDE this closure can jump the gallery to a specific slide —
       currently the siulai-rinkinys bundle's two "pick a design" <select>s (see
       sections/nv2-main-product.liquid's data-nv2-design-select block below). Those selects
       don't cause a page navigation the way a real-variant swatch's ?variant= link does, so
       they have no other way to reach the gallery. Direct assignment is safe here: exactly
       one .nv2-pdp__gallery ever exists on a product page. */
    window.nv2GalleryGoTo = goTo;

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        setActive(currentIndex());
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', function () { goTo(currentIndex(), false); });

    var initialActive = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
    /* On first paint track.clientWidth can still measure 0 (layout not yet committed for this
       flex/grid track), which used to make the pixel-offset math resolve to 0 regardless of
       initialActive and silently scroll to slide 1 instead of the variant's own photo — the
       counter text (server-rendered) still showed the right number, masking the bug. Two
       rAFs push the jump past that first, still-unsettled layout pass without any visible
       flash (still an 'instant' scroll, just one/two frames later). */
    if (initialActive > 0) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { goTo(initialActive, false); });
      });
    }
  });

  /* siulai-rinkinys bundle's "1-asis/2-asis dizainas" <select>s (sections/nv2-main-product.
     liquid) carry a data-nv2-design-slides JSON map of {designLabel: 0-based slide index},
     built server-side from each design's OWN Shopify variant image — the same photo a real
     swatch click would show. On change, jump the gallery there so picking a design in either
     dropdown previews it exactly like picking a color does for the 5-vnt. tier. A design with
     no matching photo (dv_index -1 in the Liquid) is simply left alone rather than jumping to
     a wrong slide. */
  document.querySelectorAll('[data-nv2-design-select]').forEach(function (select) {
    var raw = select.getAttribute('data-nv2-design-slides');
    if (!raw) return;
    var map;
    try {
      map = JSON.parse(raw);
    } catch (e) {
      return;
    }
    select.addEventListener('change', function () {
      var idx = map[select.value];
      if (typeof idx === 'number' && idx >= 0 && typeof window.nv2GalleryGoTo === 'function') {
        window.nv2GalleryGoTo(idx, false);
      }
    });
  });

  document.querySelectorAll('[data-nv2-thumbs-track]').forEach(function (track) {
    var step = 122;
    var up = track.parentElement.querySelector('[data-nv2-thumbs-up]');
    var down = track.parentElement.querySelector('[data-nv2-thumbs-down]');
    if (up) up.addEventListener('click', function () { track.scrollBy({ top: -step, behavior: 'smooth' }); });
    if (down) down.addEventListener('click', function () { track.scrollBy({ top: step, behavior: 'smooth' }); });
  });

  document.querySelectorAll('[data-nv2-tab-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var target = trigger.getAttribute('data-nv2-tab-trigger');
      document.querySelectorAll('[data-nv2-tab-trigger]').forEach(function (t) { t.classList.remove('is-active'); });
      document.querySelectorAll('[data-nv2-tab-panel]').forEach(function (p) { p.hidden = true; });
      trigger.classList.add('is-active');
      var panel = document.querySelector('[data-nv2-tab-panel="' + target + '"]');
      if (panel) panel.hidden = false;
    });
  });

  var stickyBar = document.querySelector('[data-nv2-sticky-atc]');
  var buyBox = document.querySelector('[data-nv2-buybox]');
  if (stickyBar && buyBox) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(buyBox);
  }

  document.querySelectorAll('[data-nv2-size-chart-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modal = document.querySelector('[data-nv2-size-chart-modal]');
      if (modal) modal.hidden = false;
    });
  });
  document.querySelectorAll('[data-nv2-size-chart-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modal = document.querySelector('[data-nv2-size-chart-modal]');
      if (modal) modal.hidden = true;
    });
  });

  document.querySelectorAll('[data-nv2-pdp-qty-minus], [data-nv2-pdp-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.querySelector('[data-nv2-pdp-qty-input]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      val = btn.hasAttribute('data-nv2-pdp-qty-plus') ? val + 1 : Math.max(1, val - 1);
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
  });

  document.querySelectorAll('[data-nv2-swatch]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('[data-nv2-swatch-group]');
      if (!group) return;
      group.querySelectorAll('[data-nv2-swatch]').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var display = group.querySelector('[data-nv2-swatch-value]');
      if (display) display.textContent = btn.getAttribute('data-nv2-swatch');
    });
  });

  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('section.nv2').forEach(function (section) {
      if (section.classList.contains('nv2-hero-section')) return;
      /* nv2-no-reveal: an opt-out for a specific section instance (set via that section's
         own disable_animation setting in Liquid, e.g. sections/nv2-seo-faq.liquid on the
         Kontaktai page) — the section is skipped entirely here so it never gets .nv2-reveal
         (opacity:0 until scrolled into view) in the first place, and is simply visible on
         load like any ordinary section. Per explicit request: only that page's instance,
         the homepage's own instance of the same section keeps the normal reveal-on-scroll. */
      if (section.classList.contains('nv2-no-reveal')) return;
      if (section.querySelector('.nv2-catrail__item')) return;
      section.classList.add('nv2-reveal');
      revealObserver.observe(section);
    });

    document.querySelectorAll('.nv2-catrail__item').forEach(function (card, i) {
      card.classList.add('nv2-reveal');
      card.style.transitionDelay = Math.min(i, 8) * 60 + 'ms';
      revealObserver.observe(card);
    });
  }
})();
